import { SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

export const PreviewInvoiceSheetFallback = () => {
  return (
    <>
      <SheetHeader>
        <SheetTitle>
          <Skeleton className="h-5 w-30" />
        </SheetTitle>
      </SheetHeader>
      <div className="px-4 overflow-y-auto w-full pb-2">
        <div className="space-y-6">
          <div className="rounded-md border">
            <Table className="w-full table-fixed">
              <TableHeader>
                <TableRow className="bg-muted/50 hover:bg-muted/50">
                  <TableHead>
                    <Skeleton className="h-6 w-25 rounded" />
                  </TableHead>
                  <TableHead>
                    <div className="flex justify-end">
                      <Skeleton className="h-6 w-15 rounded" />
                    </div>
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {Array.from({ length: 3 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell className="px-2">
                      <Skeleton className="h-5 w-32 rounded" />
                    </TableCell>
                    <TableCell>
                      <div className="flex justify-end">
                        <Skeleton className="h-5 w-15 rounded" />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="flex flex-col items-end gap-2 text-sm">
            <div className="flex w-full justify-between">
              <span>Subtotal</span>
              <span className="tabular-nums">
                <Skeleton className="h-5 w-15 rounded" />
              </span>
            </div>
            <div className="flex w-full justify-between">
              <span>Tax</span>
              <span className="tabular-nums">
                <Skeleton className="h-5 w-15 rounded" />
              </span>
            </div>
            <div className="flex w-full justify-between border-t pt-2 font-medium">
              <span>Total</span>
              <span className="tabular-nums">
                <Skeleton className="h-5 w-15 rounded" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
